"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _NavMenuItem = require("../NavMenuItem.styled");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ChevronDown = function ChevronDown(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
  }));
};

ChevronDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var MenuItem = function MenuItem(props) {
  var showBackground = props.showBackground,
      hasSublinks = props.hasSublinks,
      index = props.index,
      link = props.link,
      to = props.to,
      target = props.target,
      children = props.children,
      linkType = props.linkType;
  return _react.default.createElement(_NavMenuItem.StyledMenuListItem, {
    showBackground: showBackground,
    hasSublinks: hasSublinks,
    key: "main-link-".concat(index)
  }, _react.default.createElement(_NavMenuItem.StyledMenuItemLink, {
    primary: linkType === 'primary',
    secondary: linkType === 'secondary',
    tertiary: linkType === 'tertiary',
    href: link,
    to: to,
    target: target
  }, children), hasSublinks && _react.default.createElement(ChevronDown, null));
};
/**
 * Definition of default values for component props
 */


exports.MenuItem = MenuItem;
MenuItem.defaultProps = {
  link: undefined,
  to: undefined,
  target: undefined,
  alt: undefined,
  isDesktop: true,
  showBackground: false,
  hasSublinks: false,
  index: undefined,
  linkType: 'primary'
};
MenuItem.propTypes = {
  link: _propTypes.default.string,
  to: _propTypes.default.string,
  target: _propTypes.default.string,
  alt: _propTypes.default.string,
  isDesktop: _propTypes.default.bool,
  showBackground: _propTypes.default.bool,
  hasSublinks: _propTypes.default.bool,
  index: _propTypes.default.number,
  linkType: (0, _propTypes.oneOf)(['primary', 'secondary', 'tertiary', undefined])
};